import { render } from "./FieldErrors.vue?vue&type=template&id=f4675cfa"
import script from "./FieldErrors.vue?vue&type=script&lang=ts"
export * from "./FieldErrors.vue?vue&type=script&lang=ts"
script.render = render

export default script